import Pagination from 'react-bootstrap/Pagination';
import { useState } from "react";

function PageList(rowsCount, callBack, init=false) {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    if (init) {
        setCurrentPage(1);
        init = false;
    }
    const maxPage = Math.ceil(rowsCount / pageSize);
    const minPage = 1;
    let allPage = [];
    for(let i = minPage; i <= maxPage; i++){
        allPage.push(i);
    }
    const prePage = currentPage - 1 > minPage ? currentPage - 1 : minPage;
    const nextPage = currentPage + 1 < maxPage ? currentPage + 1 : maxPage;

    if (currentPage > maxPage) {
        setCurrentPage(maxPage);
        callBack(maxPage, pageSize);
    }

    return (
        <>
            <Pagination>
                <button className='btn btn-sm btn-secondary me-2'>{rowsCount}</button>
                <Pagination.First onClick={()=>{setCurrentPage(minPage);callBack(minPage, pageSize)}} />
                <Pagination.Prev onClick={()=>{setCurrentPage(prePage);callBack(prePage, pageSize)}} />
                {
                    allPage.map((item) => (
                        <Pagination.Item 
                            key={item} 
                            active={item === currentPage} 
                            onClick={()=>{setCurrentPage(item);callBack(item, pageSize);}}
                            hidden={!(item > (currentPage - 6) && item < (currentPage + 6))}
                        >
                            {item}
                        </Pagination.Item>
                    ))
                }
                <Pagination.Next onClick={()=>{setCurrentPage(nextPage);callBack(nextPage, pageSize)}} />
                <Pagination.Last onClick={()=>{setCurrentPage(maxPage);callBack(maxPage, pageSize)}} />
                <input 
                    type='number' 
                    min={minPage} 
                    max={maxPage} 
                    step={1}
                    placeholder=' '
                    pattern='^[1-9][0-9]*$'
                    className='form-control form-control-sm' 
                    style={{maxWidth: '60px'}} 
                    onKeyDown={
                        (e)=>
                            {
                                try{
                                    if(e.key === "Enter") {
                                        if(parseInt(e.target.value) && /^[1-9][0-9]*$/img.test(e.target.value + "")){
                                            setCurrentPage(parseInt(e.target.value)); 
                                            callBack(parseInt(e.target.value), pageSize);
                                            e.target.value = '';
                                        }
                                    }
                                } catch (error) {
                                    console.error(error);
                                }
                            }       
                        } 
                />
                <select 
                    className='form-select form-select-sm'
                    style={{maxWidth: '60px'}}
                    defaultValue={50}
                    onChange={(e) => {
                        setPageSize(e.target.value);
                        callBack(currentPage, e.target.value);
                    }}
                >
                    <option key={10} value={10}>10</option>
                    <option key={30} value={30}>30</option>
                    <option key={50} value={50}>50</option>
                    <option key={100} value={100}>100</option>
                </select>
            </Pagination>
        </>
        
    );
}

export default PageList;